import React, { useEffect } from 'react';
import Modal from './Modal';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlask } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Form from '../Form/Form';
import InputText from '../Form/Fields/InputText';
import InputDate from '../Form/Fields/InputDate';
import Select from '../Form/Fields/Select';
import { API_BASE_URL } from '../../api';
import { useNavigate } from 'react-router-dom';
import { toastCreated } from '../../utils/ToastLink';

const TYPE_OPTIONS = [
    { value: 'LABORATOIRE', label: 'Laboratoire' },
    { value: 'REPARTITEUR', label: 'Répartiteur' },
];

export default function CreateLaboratoryModal({ show, onClose, onSaved, laboratory = null }) {
    const navigate = useNavigate();
    const isEdit = !!laboratory?.id;

    const defaultValues = {
        name:         laboratory?.name         ?? '',
        email:        laboratory?.email        ?? '',
        telephone:    laboratory?.telephone    ?? '',
        creationDate: laboratory?.creationDate  ?? '',
        type:         laboratory?.type         ?? 'LABORATOIRE',
    };

    const onSubmit = (data) => {
        const request = isEdit
            ? axios.put(`${API_BASE_URL}/api/v1/laboratories/${laboratory.id}`, data, { withCredentials: true })
            : axios.post(`${API_BASE_URL}/api/v1/laboratories`, data, { withCredentials: true });

        request
            .then(({ data }) => {
                if (isEdit) {
                    toast.success('Laboratoire mis à jour.');
                } else {
                    toastCreated(navigate, 'Laboratoire créé.', data?.id && `/suppliers/${data.id}`);
                }
                onSaved(data);
                onClose();
            })
            .catch(() => toast.error('Une erreur est survenue.'));
    };

    return (
        <Modal
            title={isEdit ? 'Modifier le laboratoire' : 'Nouveau laboratoire'}
            show={show}
            onClose={onClose}
            icon={faFlask}
            iconBg="#f5f3ff"
            iconColor="#7c3aed"
        >
            <Form id="labForm" onSubmit={onSubmit} defaultValues={defaultValues} key={laboratory?.id ?? 'new'}>
                <div className="mb-3">
                    <label className="form-label">Nom <span className="text-danger">*</span></label>
                    <InputText name="name" placeholder="Nom du laboratoire" validationRules={{ required: 'Le nom est requis' }} />
                </div>

                <div className="row g-3 mb-3">
                    <div className="col-6">
                        <label className="form-label">Email</label>
                        <InputText name="email" placeholder="contact@laboratoire.ma" />
                    </div>
                    <div className="col-6">
                        <label className="form-label">Téléphone</label>
                        <InputText name="telephone" placeholder="05 XX XX XX XX" />
                    </div>
                </div>

                <div className="row g-3 mb-3">
                    <div className="col-6">
                        <label className="form-label">Date de création</label>
                        <InputDate name="creationDate" />
                    </div>
                    <div className="col-6">
                        <label className="form-label">Type</label>
                        <Select name="type" options={TYPE_OPTIONS} />
                    </div>
                </div>

                <div className="d-flex justify-content-end gap-2 pt-2">
                    <button type="submit" form="labForm" className="modal-btn-primary">
                        {isEdit ? 'Enregistrer' : 'Créer'}
                    </button>
                </div>
            </Form>
        </Modal>
    );
}
